import React, {Suspense} from 'react';
import useLoadAnimation from './useLoadAnimation';

const ReactLottie = React.lazy(() => import('lottie-react'));

const Lottie = ({url, ...rest}) => {
  const {isLoaded, animation} = useLoadAnimation(url);

  if (!isLoaded) return null;

  return (
    <Suspense fallback={<span>Loading...</span>}>
      <ReactLottie animationData={animation} {...rest} />
    </Suspense>
  );
};

export default Lottie;
